<div data-testid="stock-delivery-result-page" class="p-6 flex-table-page routed-flex-table-page">
  <!-- Search Form -->
  <app-search-form
    data-testid="stock-delivery-result-search-form"
    [searchFormat]="searchFormat()"
    (formSearch)="onSearch($event)"
    (formReset)="onReset()"
  >
    <div slot="actions">
      <app-button
        [testId]="'stock-delivery-result-column-config-btn'"
        type="success"
        [outlined]="true"
        icon="view_column"
        (emitOnClick)="onColumnConfigClick($event)"
      ></app-button>
    </div>
  </app-search-form>

  <!-- Data Table -->
  <div class="table-section flex-table-section">
    <advanced-data-table
      data-testid="stock-delivery-result-table"
      #advancedTable
      [dataSource]="dataSource()"
      [defaultColumns]="defaultColumns()"
      [flexibleColumns]="flexibleColumns()"
      [loading]="loading()"
      [rows]="searchParams().size"
      [first]="(searchParams().page - 1) * searchParams().size"
      [totalRecords]="totalRecords()"
      [sortField]="sortField()"
      [sortOrder]="sortOrder()"
      scrollHeight="flex"
      [showInternalColumnConfigButton]="false"
      class="w-full"
      (pageChange)="onPageChange($event)"
      (sortChange)="onSortChange($event)"
    >
      <!-- Custom Template for Outbound Type, Warehouse/Store Name, and Creation Time -->
      <ng-template
        #customTemplate
        let-value
        let-rowData="rowData"
        let-column="column"
      >
        @if (column.prop === "outType") {
          <!-- Outbound Type -->
          <span class="text-xs text-gray-700">
            {{
              getOutboundTypeLabel(rowData.outType || rowData.outTypeMeaning)
            }}
          </span>
        } @else if (column.prop === "outLogicWarehouseName") {
          <!-- Warehouse/Store Name: outLogicWarehouseName for transfer order, shopName for sales order -->
          <span class="text-xs text-gray-700">
            {{ getWarehouseOrStoreName(rowData) }}
          </span>
        } @else if (column.prop === "creationDate") {
          <!-- Creation Time -->
          <span class="text-xs text-gray-600">
            {{ formatCreationTime(value) }}
          </span>
        }
      </ng-template>

      <!-- Custom Actions Template -->
      <ng-template #actionsTemplate let-record>
        <div class="inline-flex items-center gap-2 whitespace-nowrap">
          @if (canRead()) {
            <app-button
              [testId]="'stock-delivery-result-action-view-' + record.id"
              class="action-view"
              [label]="'common.actions.view' | translate"
              type="action"
              (emitOnClick)="onViewDetails(record)"
            ></app-button>
          }
        </div>
      </ng-template>
    </advanced-data-table>
  </div>
</div>
